import * as React from "react";
import { Block } from "src/utils/blocknote";
import styled from "styled-components";

interface Props {
  content: Block["content"];
}

export function Content({ content }: Props) {
  return (
    <Root>
      {Array.isArray(content) &&
        content.map((el) => {
          switch (el.type) {
            case "text":
              return el.text;
            case "link":
              return null;
          }
        })}
    </Root>
  );
}

const Root = styled.div`
  font-size: 16px;
  flex-grow: 1;
`;
